// Kingz Speed — custom-image-popup.js (deferred)
// JS-error fix 2026-10-18: openImagePopup / closeImagePopup are now defined as soon as this
// file runs (previously only 5s after DOMContentLoaded, so early "Size Chart" taps threw
// "ReferenceError: openImagePopup is not defined"). Elements are looked up lazily, so the
// popup behaves exactly as before. Listeners are attached on DOMContentLoaded (cheap, no work).
(function() {
  function getContainer() { return document.getElementById('image-popup-container'); }

  window.openImagePopup = function() {
    var imagePopupContainer = getContainer();
    if (imagePopupContainer) imagePopupContainer.style.display = 'flex';
  };

  function closeImagePopup() {
    var imagePopupContainer = getContainer();
    if (imagePopupContainer) imagePopupContainer.style.display = 'none';
  }
  window.closeImagePopup = window.closeImagePopup || closeImagePopup;

  function bind() {
    var imagePopupCloseButton = document.getElementById('image-popup-close');
    if (imagePopupCloseButton) {
      imagePopupCloseButton.addEventListener('click', closeImagePopup);
    }

    window.addEventListener('click', function(event) {
      if (event.target === getContainer()) {
        closeImagePopup();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeImagePopup();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
